// Cookie Consent Utility Functions

export interface CookieConsent {
  status: 'accepted' | 'declined' | 'essential' | null;
  date: string | null;
}

export const getCookieConsent = (): CookieConsent => {
  if (typeof window === 'undefined') {
    return { status: null, date: null };
  }

  const status = localStorage.getItem('cookieConsent') as CookieConsent['status'];
  const date = localStorage.getItem('cookieConsentDate');

  return { status, date };
};

export const hasAcceptedAnalytics = (): boolean => {
  const consent = getCookieConsent();
  return consent.status === 'accepted';
};

export const hasAcceptedEssential = (): boolean => {
  const consent = getCookieConsent();
  return consent.status === 'accepted' || consent.status === 'essential';
};

export const clearCookieConsent = (): void => {
  if (typeof window === 'undefined') return;
  
  localStorage.removeItem('cookieConsent');
  localStorage.removeItem('cookieConsentDate');
};

export const shouldShowAnalytics = (): boolean => {
  return hasAcceptedAnalytics();
};

export const shouldShowEssentialCookies = (): boolean => {
  return hasAcceptedEssential();
}; 